import Tooltip from "components/ui/Tooltip";
import { Badge, IconButton } from "@mui/material";
import { ReactComponent as Sort } from "assets/icons/sort.svg";
import { ReactComponent as Filter } from "assets/filter/filter.svg";
import ClientInnerCard from "../ClientInnerCard";
import { useEffect } from "react";
import { Padding } from "@mui/icons-material";

const ClientLeftSection = ({ data, header, type = "ledger", selectedCard, setSelectedCard, isFetching }) => {
  let headerName = header?.split("-")[0];
  let headerCount = header?.split("-")[1];

  const cardStyle = {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    // border: "1px solid #e2e8f0",
    height: "100%",
    width: "420px",
    padding: "0px 0px 150px",
  };

  const cardHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 8px",
    backgroundColor: "transparent",
  };

  const headerIconStyle = {
    color: "#64748b",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    transition: "background-color 0.2s",
    display: "flex",
    gap: "6px",
  };

  const cardContentStyle = {
    flex: 1,
    overflowY: "auto",
    padding: "8px 0px",
    scrollbarWidth: "thin",
    scrollbarColor: "#333333 #000000",
  };

  // useEffect(() => {
  //   if (!selectedCard && data?.items?.length > 0) {
  //     setSelectedCard(data.items[0]);
  //   }
  // }, [data, selectedCard, setSelectedCard]);

  return (
    <div style={cardStyle}>
      <div style={cardHeaderStyle}>
        <h2 style={{ fontSize: "16px", fontWeight: 600, color: "#fff", lineHeight: "100%" }}>
          <span style={{ fontWeight: "300", fontFamily: "poppins", fontSize: "16px" }}>{headerName} -</span>
          <span style={{ fontWeight: "600", fontFamily: "poppins", fontSize: "16px" }}>{headerCount}</span>
        </h2>
        <div style={headerIconStyle}>
          {type !== "quote-order" && type !== "wip" && (
            <Tooltip title="Filter">
              <IconButton disableRipple disableFocusRipple>
                <Badge color="success">
                  <Filter style={{ width: "16px", height: "16px" }} />
                </Badge>
              </IconButton>
            </Tooltip>
          )}

          {type !== "wip" && (
            <Tooltip title="Sort By">
              <IconButton disableRipple disableFocusRipple sx={{ padding: "0px !important" }}>
                <Sort style={{ width: "18px", height: "18px" }} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>

      <div style={cardContentStyle}>
        <ClientInnerCard data={data} type={type} selectedCard={selectedCard} setSelectedCard={setSelectedCard} isFetching={isFetching} />
      </div>
    </div>
  );
};

export default ClientLeftSection;
